import React from 'react'
import {observer} from 'mobx-react-lite'
import {Stack, Text} from '../../vanilla'
import ReactMarkdown from 'react-markdown'
import { ProductInforVizProps } from '../../types/cms'

export const ProductInformationVizualization = observer(({content}: ProductInforVizProps) => {
  if (!content) {
    return null
  }

  return (
    <Stack padding="20px" spacing="16px">
      <Text variant="text6">{content?.title}</Text>
      <ReactMarkdown
        components={{
          p: ({...props}) => {
            return (
              <Text variant="text1" lineHeight="short">
                {props?.children}
              </Text>
            )
          },
        }}
      >
        {content?.copy || ''}
      </ReactMarkdown>
    </Stack>
  )
})
